import { NewsArticle, NewsSource, NewsTopic, PaginatedResponse } from '../types';
import { API_BASE_URL } from '../config';

class NewsService {
  async getArticles(
    limit = 10, 
    skip = 0, 
    topicId?: string, 
    date?: string
  ): Promise<PaginatedResponse<NewsArticle>> {
    const params = new URLSearchParams({
      limit: limit.toString(),
      skip: skip.toString(),
      ...(topicId && { topic_id: topicId }),
      ...(date && { date: date }),
    });

    const response = await fetch(`${API_BASE_URL}/news/articles/?${params}`);
    if (!response.ok) {
      throw new Error('Failed to fetch articles');
    }
    return response.json();
  }

  async getArticle(articleId: string): Promise<NewsArticle> {
    const response = await fetch(`${API_BASE_URL}/news/articles/${articleId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch article');
    }
    return response.json();
  }

  async getSources(): Promise<NewsSource[]> {
    const response = await fetch(`${API_BASE_URL}/news/sources/`);
    if (!response.ok) {
      throw new Error('Failed to fetch sources');
    }
    return response.json();
  }

  async getTopics(): Promise<NewsTopic[]> {
    const response = await fetch(`${API_BASE_URL}/news/topics/`);
    if (!response.ok) {
      throw new Error('Failed to fetch topics');
    }
    return response.json();
  }
}

export const newsService = new NewsService();
